
















































































import Component from "vue-class-component";
import StandardList from "front-component/components/List.vue";
import Http from "front-component/Http";
import InsertionBroadcastDate from "../insertion/list/fields/BroadcastDate.vue";
import InsertionProofsDate from "../insertion/list/fields/ProofsDate.vue";
import InsertionCampaign from "../insertion/list/fields/Campaign.vue";
import InsertionStatus from "../insertion/list/fields/Status.vue";
import InsertionQuotationNumber from "../insertion/list/fields/QuotationNumber.vue";
import InsertionProductCode from "../insertion/list/fields/ProductCode.vue";
import InsertionNumber from "../insertion/list/fields/InsertionNumber.vue";
import InsertionSupplierEmail from "../insertion/list/fields/SupplierEmail.vue";
import InsertionPigeDate from "../insertion/list/fields/PigeDate.vue";
import InsertionRepository from "@/repositories/insertion/InsertionRepository";
import InsertionPubOrder from "../insertion/list/fields/OpNumber.vue";
import LineCheckFollowUpRules from "@/components/admin/LineCheckFollowUpRules.vue";
import LineCheckJustifOnlineRules from "@/components/admin/LineCheckJustifOnlineRules.vue";
import {Getter} from "vuex-class";

const components = {
    InsertionBroadcastDate,
    InsertionProofsDate,
    InsertionStatus,
    InsertionCampaign,
    InsertionQuotationNumber,
    InsertionProductCode,
    InsertionNumber,
    InsertionSupplierEmail,
    InsertionPigeDate,
    InsertionPubOrder,
    LineCheckFollowUpRules,
    LineCheckJustifOnlineRules,
};

@Component({ components })
export default class List extends StandardList {
    protected route: string = "get_insertion";
    protected fields: string[] = [];

    @Getter("isDsi") public isDsi!: boolean;

    public created(): void {
        this.fields = Http.computeStandardFields(components, "insertion");
    }

    protected link(): string {
        return InsertionRepository.getSearchUrl();
    }

    protected checkRulesFollowUp(insertion: any): boolean {
        return !(!insertion.quotation.quotationNumber || insertion.status === "cancelled");
    }

    protected checkRulesJustifOnline(insertion: any): boolean {
        const date = Number(new Date(insertion.advertisingSpace.broadcastStartDate));

        return  Date.now() >= date && insertion.status !== "cancelled" && !insertion.pigeDate &&
            !insertion.proofReceptionDate && insertion.opNumber && insertion.advertisingSpace.media !== "TELEVISION";
    }
}
